import React from 'react';

export default (props) => (
	<div className="form-element ">
		<div className="input input-select">
			<label className={`input input-text ${props.error && (props.displayError || (props.value !== undefined && props.value !== "")) ? 'error' : ''} ${props.disabled ? 'disabled' : ''}`}>
				<span className={`label ${props.bold && 'bold-label'}`}>{props.label}</span>
				<div className="group">
					<select id="select_1" name="select_1" defaultValue="" {...props}>
						<option value="" className="placeholder" disabled> {props.placeholder}</option>
						{props.options.map((o, i) => <option value={o.key} key={o.key || i}>
							{o.name || ""}
						</option>)}
					</select>
					<span aria-label="Control" className="icon-control">
            <span className="icon" 
                style={{
                    WebkitMaskImage: 'url(https://static.tui.com/assets/v2/icons/tui-light/chevron-updown.svg)',
                    maskImage: 'url(https://static.tui.com/assets/v2/icons/tui-light/chevron-updown.svg)',
                    color: 'currentColor'
                }}
            ></span>
        </span>
				</div>
			</label >
			<span className="input-message">
				<p className="message">{((props.value !== undefined && props.value !== "") || props.displayError) && (props.error || props.message)}</p>
			</span>
		</div >
	</div >
)